module.exports = __webpack_public_path__ + "static/img/new_home_4.f937bfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_grande/new_home_4.jpg
// module id = ZcxF
// module chunks = 1